import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import FormLayout from "@mapmycustomers/shared/types/layout/FormLayout";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import SettingPath from "@app/enum/settings/SettingPath";

import { cancelLayoutRolesAssociation } from "../../store/actions";

interface Props {
  cancelLayoutRolesAssociation: typeof cancelLayoutRolesAssociation;
  layout: FormLayout;
}

const EditAction: React.FC<Props> = ({ cancelLayoutRolesAssociation, layout }) => {
  const intl = useIntl();
  const history = useHistory();

  const handleClick = useCallback(() => {
    cancelLayoutRolesAssociation();
    history.push(`${Path.SETTINGS}/${SettingPath.FORMS_CREATE}/${layout.entity}/${layout.id}`);
  }, [cancelLayoutRolesAssociation, history, layout]);

  return (
    <Button onClick={handleClick}>
      {intl.formatMessage({
        id: "settings.formLayouts.grid.actions.edit",
        defaultMessage: "Edit",
        description: "Title of the Edit button in the Field Name column",
      })}
    </Button>
  );
};

const mapDispatchToProps = {
  cancelLayoutRolesAssociation,
};

export default connect(null, mapDispatchToProps)(EditAction);
